<script setup>
import { computed } from "vue";
import { useFileStore } from "@/store/useFileStore";

/* ==============================
 *  Props
 * ============================== */
defineProps({
  open: { type: Boolean, default: false },
});

/* ==============================
 *  Store
 * ============================== */
const fileStore = useFileStore();

/* ==============================
 *  Computed
 * ============================== */
const isShow = computed(() => fileStore.tx);
</script>

<template>
  <div
    v-if="isShow"
    class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-body bg-opacity-75"
    style="z-index: 1055"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="d-flex flex-column align-items-center gap-3">
      <div
        class="spinner-border text-primary"
        style="width: 3rem; height: 3rem"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="text-secondary small fw-medium">
        처리 중… 잠시만 기다려 주세요
      </div>
    </div>
  </div>
</template>
